import React, {Component} from 'react';
import DatePanel from './DatePanel'

import '../../Overview/overview.css'
import './filterpanel.css'

export default class DatePanelChildren extends Component {
  constructor(props) {
    super(props);

    this.state = {  
    };
  }

 render() {
    return (
      <div className="filter-row">
        <DatePanel {...this.props} />
        {this.props.children}
      </div>
    )  
  }
}
